module.exports = __webpack_public_path__ + "static/media/inetcpl_1318.7dd58887.ico";